import { ENUM_MortgageCaseStatus } from '@api-new/common';

export const ENUM_MortgageCaseStatusMap = new Map([
  [ENUM_MortgageCaseStatus.MORTGAGE_CASE_STATUS_AWAITING_APPROVAL, 'Callback requested'],
  [ENUM_MortgageCaseStatus.MORTGAGE_CASE_STATUS_OPPORTUNITY, 'Callback requested'],
  [ENUM_MortgageCaseStatus.MORTGAGE_CASE_STATUS_LEAD, 'Callback requested'],
  [ENUM_MortgageCaseStatus.MORTGAGE_CASE_STATUS_PIPELINE, 'Being advised'],
  [ENUM_MortgageCaseStatus.MORTGAGE_CASE_STATUS_CLOSED, 'Closed'],
  [ENUM_MortgageCaseStatus.MORTGAGE_CASE_STATUS_UNSPECIFIED, 'Case status UNSPECIFIED'],
  [ENUM_MortgageCaseStatus.UNRECOGNIZED, 'UNRECOGNIZED'],
]);
